import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import withAuthProtection from 'hoc/withAuthProtection';
import withPermissionProtection from 'hoc/withPermissionProtection';

// Components
import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import Tabs from './Tabs';

// Hooks
import useSnackbar from 'hooks/useSnackbar';
import useGetUserDocuments from './hooks/useGetUserTaxDocuments';

// Utilities
import isEmail from 'utilities/validateEmail';

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  header: {
    marginTop: 40,
    marginBottom: 0,
    [breakpoints.up('lg')]: {
      fontSize: 48,
      lineHeight: '56px',
    },
  },
  link: {
    color: palette.cncUI.misc.link,
  },
}));

const TaxDocuments = () => {
  const classes = useStyles();
  const notify = useSnackbar();
  const getDocuments = useGetUserDocuments();
  const [state, setState] = useState({
    loading: false,
    searchValue: '',
    searchType: 'SSN',
    w2s: [],
    w4s: [],
    td1s: [],
    logs: [],
    tab: 0,
  });
  const modify = data => setState(old => ({ ...old, ...data }));

  const search = value => {
    modify({ loading: true, w2s: [], w4s: [], td1s: [], logs: [] });
    getDocuments(!isEmail(value) ? value : '', isEmail(value) ? value : '')
      .then(documents => {
        modify({ ...documents, searchValue: value });
      })
      .catch(err => {
        notify({ type: 'error', show: true, message: err.message });
      })
      .finally(() => modify({ loading: false }));
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} id="HeaderTitle">
        <Typography variant="h2" className={classes.header}>
          Tax Document Search
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" size="long" id="HeaderBody">
          To search for tax documents please enter the user’s full SSN, SIN, or
          Email.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Tabs
          documents={state}
          refresh={search}
          onModify={modify}
          onClear={() => modify({ w2s: [], w4s: [], td1s: [], logs: [] })}
        />
      </Grid>
    </Grid>
  );
};

export default compose(
  withAuthProtection(),
  withPermissionProtection([
    'tax_documents:read',
    'tax_documents_log:read',
    'users:read',
    'tax_documents:edit',
  ]),
)(TaxDocuments);
